import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const AlmondcoSalesService = {
  dataSourceConfig(params) {
    var url = "api/AlmondcoInshellBinLotAssignment";
    return ApiService.createDataSource(url, params);
  },

  async getAlmondcoInshellSalesOrderLotAssignment(lotNo) {
    const requestScreenData = {
      url: "api/AlmondcoInshellSalesOrderLotAssignment",
      top: "1",
      filter: `LotNo eq ${lotNo}`,
      orderBy: "LotNo",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getItemDataByItemCodes(filter) {
    const requestScreenData = {
      url: "api/SaleItemCompanyBranch",
      orderBy: "ItemCode",
      filter: filter,
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  async getAlmondcoInshellSalesOrderLotAssignmentByeSalesOrderCode(
    salesOrderCode
  ) {
    const requestScreenData = {
      url: "api/AlmondcoInshellSalesOrderLotAssignment",
      top: "1000",
      filter: `SalesOrderCode eq ${salesOrderCode}`,
      orderBy: "ItemCode, LotNo, LotSquenceNo",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getAlmondcoInshellBinLotAssignment(lotNo) {
    const requestScreenData = {
      url: "api/AlmondcoInshellBinLotAssignment",
      apply: `filter(LotNo eq ${lotNo})/groupby((LotNo,LotSequenceNo))`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async saveAlmondcoInshellBinLotAssignment(payload, orderId) {
    return await ApiService.put(
      `api/Save_AlmondcoInshellSalesOrderLotAssignment`,
      orderId,
      payload,
      "Integer"
    );
  },
};

export { AlmondcoSalesService };
